if (!window.Eurus.loadedScript.has('card-size-bar.js')) {
  window.Eurus.loadedScript.add('card-size-bar.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xCardSizeBar', () => ({
        overflow: false,
        canPrev: false,
        canNext: false,
        isRtl: false,
        init() {
          this.isRtl = getComputedStyle(this.$refs.track).direction === 'rtl';
          this.$nextTick(() => this.update());
          if (window.ResizeObserver) {
            new ResizeObserver(() => this.update()).observe(this.$refs.track);
          }
        },
        update() {
          const track = this.$refs.track;
          if (!track) return;
          const maxScroll = track.scrollWidth - track.clientWidth;
          this.overflow = maxScroll > 1;
          // In RTL, scrollLeft goes from 0 to negative values
          const position = Math.abs(track.scrollLeft);
          this.canPrev = position > 1;
          this.canNext = position < maxScroll - 1;
        },
        scroll(direction) {
          const track = this.$refs.track;
          const step = direction * track.clientWidth * 0.7;
          track.scrollBy({ left: this.isRtl ? -step : step, behavior: 'smooth' });
        }
      }));
    });
  });
}
